import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id B4A236B3-E14B-4A64-8EDD-A48128013388
 * name angle-acute
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/angle-acute.svg
 * tags
 * - Math 
 */
export const AngleAcuteIcon = createSvgIcon(<><path d="M20,19H4.09L14.18,4.43L15.82,5.57L11.28,12.13C12.89,12.96 14,14.62 14,16.54C14,16.7 14,16.85 13.97,17H20V19M7.91,17H11.96C12,16.85 12,16.7 12,16.54C12,15.28 11.24,14.22 10.14,13.78L7.91,17Z" /></>, 'AngleAcuteIcon');
export default AngleAcuteIcon